<template>
  <v-container fill-height>
    <v-layout align-center justify-center column>
        <v-progress-circular
          indeterminate
          color="accent"
        ></v-progress-circular>
        <br>
        <v-label>
          Saindo da aplicação
        </v-label>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  async created(){
    await this.$store.dispatch('logoff');
    setTimeout(() => {
      this.$router.push('/login');
    }, 2000);
  }
}
</script>

<style>

</style>
